import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { useAuthToken } from '../../TokenContext';
import axios from 'axios';
import './ArtemyStyles.css';

const POD_CONFIGS = [
  { id: 'pod-ops', path: '/control-plane/pod-ops', label: 'OPERATIONAL', name: 'Astra Operational', color: 'var(--artemy-accent)', types: ['scrum_master', 'support_engineer'] },
  { id: 'pod-product', path: '/control-plane/pod-product', label: 'PRODUCT', name: 'Astra Product', color: 'var(--artemy-green)', types: ['product_owner'] },
  { id: 'pod-eng', path: '/control-plane/pod-eng', label: 'ENGINEERING', name: 'Astra Engineering', color: 'var(--artemy-yellow)', types: ['coder', 'tester', 'devops'] },
  { id: 'pod-mgmt', path: '/control-plane/pod-mgmt', label: 'MANAGEMENT', name: 'Astra Executive', color: 'var(--artemy-purple)', types: ['designer'] },
];

function StatusPill({ status }) {
  const map = { active: 'var(--artemy-green)', provisioning: 'var(--artemy-yellow)', stopped: 'var(--artemy-text-dim)', error: 'var(--artemy-red)' };
  const color = map[status] || 'var(--artemy-text-dim)';
  return <span style={{ fontFamily: 'var(--artemy-font-mono)', fontSize: 10, color, background: `${color}1a`, padding: '1px 6px', borderRadius: 4, border: `1px solid ${color}33`, textTransform: 'uppercase' }}>{status}</span>;
}

export default function AgentPods() {
  const history = useHistory();
  const token = useAuthToken();
  const { user } = useSelector((s) => s.auth);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token || !process.env.REACT_APP_CLIENT_LISTAGENTHANDLER) { setLoading(false); return; }
    axios.post(process.env.REACT_APP_CLIENT_LISTAGENTHANDLER, { manager_id: user?.data?.[0]?.emp_id }, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setAgents(res.data?.data || []))
      .catch(() => setAgents([]))
      .finally(() => setLoading(false));
  }, [token, user]);

  const agentsByPod = (types) => agents.filter((a) => !types.length || types.includes(a.agent_type));
  const activeCount = agents.filter((a) => a.status === 'active').length;

  return (
    <div className="artemy-fade-up">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 22 }}>
        <div>
          <div className="artemy-page-title">Agent Pods</div>
          <div className="artemy-page-sub">
            {loading ? 'Discovering agents…' : `${activeCount} agents active across ${POD_CONFIGS.length} clusters`}
          </div>
        </div>
        <button className="artemy-btn artemy-btn-primary" onClick={() => history.push('/CreateAgent')}>
          + Create Agent
        </button>
      </div>

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 32 }}><CircularProgress size={28} sx={{ color: 'var(--artemy-accent)' }} /></div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 14 }}>
          {POD_CONFIGS.map((pod) => {
            const podAgents = agentsByPod(pod.types);
            const active = podAgents.filter((a) => a.status === 'active').length;
            return (
              <div key={pod.id} onClick={() => history.push(pod.path)} className="artemy-card" style={{
                padding: 24, cursor: 'pointer', position: 'relative', overflow: 'hidden'
              }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg,${pod.color},transparent)` }} />
                <div style={{ fontFamily: 'var(--artemy-font-mono)', fontSize: 9, letterSpacing: '1.2px', textTransform: 'uppercase', color: pod.color, marginBottom: 8, opacity: .9 }}>{pod.label}</div>
                <div style={{ fontFamily: 'var(--artemy-font-display)', fontSize: 17, fontWeight: 700, marginBottom: 6 }}>{pod.name}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, color: 'var(--artemy-text-secondary)', marginBottom: 14 }}>
                  <div style={{ width: 5, height: 5, borderRadius: '50%', background: 'var(--artemy-green)', animation: 'artemy-pulse 2s infinite' }} />
                  {active} agents active
                </div>
                {podAgents.slice(0, 4).map((agent) => (
                  <div key={agent.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>
                    <div style={{ fontSize: 12.5, fontWeight: 500, color: 'var(--artemy-text-primary)' }}>{agent.name}</div>
                    <StatusPill status={agent.status} />
                  </div>
                ))}
                {podAgents.length === 0 && (
                  <div style={{ fontSize: 12, color: 'var(--artemy-text-dim)', marginTop: 8 }}>No agents assigned yet</div>
                )}
                {podAgents.length > 4 && (
                  <div style={{ fontSize: 11, color: pod.color, marginTop: 10, fontWeight: 500 }}>+{podAgents.length - 4} more agents →</div>
                )}
              </div>
            );
          })}
        </div>
      )}
      <div style={{ height: 40 }} />
    </div>
  );
}
